import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';

const WooCommerceSchnittstelleFAQ = () => {
    const { t } = useTranslations();

    const faqs = [
        {
            question: t('woocommerceSchnittstelle_faq_question1'),
            answer: t('woocommerceSchnittstelle_faq_answer1'),
        },
        {
            question: t('woocommerceSchnittstelle_faq_question2'),
            answer: t('woocommerceSchnittstelle_faq_answer2'),
        },
        {
            question: t('woocommerceSchnittstelle_faq_question3'),
            answer: t('woocommerceSchnittstelle_faq_answer3'),
        },
        {
            question: t('woocommerceSchnittstelle_faq_question4'),
            answer: t('woocommerceSchnittstelle_faq_answer4'),
        },
        {
            question: t('woocommerceSchnittstelle_faq_question5'),
            answer: t('woocommerceSchnittstelle_faq_answer5'),
        },
        {
            question: t('woocommerceSchnittstelle_faq_question6'),
            answer: t('woocommerceSchnittstelle_faq_answer6'),
        }
    ];

    return (
        <section className="wc-faq pt-100 pb-100">
            <div className="container wc-faq__content">
                <div className="row mb-5">
                    <div className="col-12 text-center">
                        <FadeInAnimation direction="up" delay={50}>
                            <span className="wc-section-badge">
                                {t('woocommerceSchnittstelle_faq_badge')}
                            </span>
                            <h2 className="wc-section-title">
                                {t('woocommerceSchnittstelle_faq_title')}
                            </h2>
                        </FadeInAnimation>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        {faqs.map((faq, index) => (
                            <FadeInAnimation key={index} direction="up" delay={100 + (index * 50)}>
                                <details className="wc-faq__item">
                                    <summary>
                                        <span>{faq.question}</span>
                                        <span className="wc-faq__toggle">+</span>
                                    </summary>
                                    <div className="wc-faq__answer">
                                        <p>{faq.answer}</p>
                                    </div>
                                </details>
                            </FadeInAnimation>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WooCommerceSchnittstelleFAQ;
